var map = {
	"./Certificate-MC-2700-218x300.jpg": 695,
	"./Rajesh-Shenoy (1).jpg": 420,
	"./doctor-01.jpg": 204,
	"./doctor-02.jpg": 230,
	"./doctor-03.jpg": 308,
	"./doctor-04.jpg": 309,
	"./doctor-05.jpg": 310,
	"./doctor-06.jpg": 311,
	"./doctor-07.jpg": 312,
	"./doctor-08.jpg": 313,
	"./doctor-09.jpg": 696,
	"./doctor-10.jpg": 697,
	"./doctor-11.jpg": 698,
	"./doctor-12.jpg": 699,
	"./doctor-profile08.jpg": 700,
	"./doctor-thumb-01.jpg": 109,
	"./doctor-thumb-02.jpg": 49,
	"./doctor-thumb-03.jpg": 101,
	"./doctor-thumb-04.jpg": 102,
	"./doctor-thumb-05.jpg": 148,
	"./doctor-thumb-06.jpg": 85,
	"./doctor-thumb-07.jpg": 206,
	"./doctor-thumb-08.jpg": 207,
	"./doctor-thumb-09.jpg": 208,
	"./doctor-thumb-10.jpg": 209,
	"./doctor-thumb-11.jpg": 701,
	"./doctor-thumb-12.jpg": 702,
	"./home-certificate.jpg": 421,
	"./homedirector.jpg": 422,
	"./infrastrucure_1.jpg": 410,
	"./infrastrucure_10.jpg": 419,
	"./infrastrucure_2.jpg": 411,
	"./infrastrucure_3.jpg": 412,
	"./infrastrucure_4.jpg": 413,
	"./infrastrucure_5.jpg": 414,
	"./infrastrucure_6.jpg": 415,
	"./infrastrucure_7.jpg": 416,
	"./infrastrucure_8.jpg": 417,
	"./infrastrucure_9.jpg": 418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 694;